import React from 'react';
import { HeartPulseIcon, ScissorsIcon, BandageIcon, StethoscopeIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { audiences } from '../../data/content';
const icons = [ScissorsIcon, HeartPulseIcon, BandageIcon, StethoscopeIcon];
export function Audience() {
  return <section className="bg-white px-5 py-14 md:py-20" data-id="element-63" data-mp="1hw6bqjv03sqf">
      <div className="mx-auto max-w-5xl" data-id="element-64" data-mp="25owkkk7lxvwh">
        <SectionHeading title="Designed for Professionals Who Need Practical Tools — Not Another Academic Textbook" subtitle="This blueprint is intended for:" data-id="element-65" data-mp="25lqt4ybiahxl" />

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-66" data-mp="1wmvqfw7o7pz1">
          {audiences.map((a, i) => {
          const Icon = icons[i];
          return <div key={a.title} className="flex items-start gap-4 rounded-2xl bg-teal-light p-5" data-id="element-67" data-mp="l7qiodson18k" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-teal text-white" data-id="element-68" data-mp="q7cvim4lmfgu">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-69" data-mp="zn2xx9drrwgz" />
                </span>
                <div data-id="element-70" data-mp="uo9w4e7uhtwn">
                  <h3 className="text-lg font-extrabold leading-tight text-navy" data-id="element-71" data-mp="uorqf5ay5y1x">{a.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-navy/75" data-id="element-72" data-mp="19m29azpx667o">{a.text}</p>
                </div>
              </div>;
        })}
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-sm leading-relaxed text-navy/60" data-id="element-73" data-mp="1ikdv8ofucfts">
          The materials support established clinical responsibilities and do not expand professional scope of practice.
        </p>

        <SectionCTA label="Yes, This Is for Me" data-id="element-74" data-mp="1safn7rbbeidz" />
      </div>
    </section>;
}